module.exports = __webpack_public_path__ + "img/logo.dae44c93.png";